// ===============================
// PRODUCT SWIPER WITH THUMBS + FRACTION PAGINATION
// ===============================

document.querySelectorAll(".prod-gallery").forEach((section) => {
  const mainSwiperEl = section.querySelector(".gallery-swiper");
  if (!mainSwiperEl) return;

  // find the overall product hero wrapper so we can grab thumbnails from the other column
  const wrapper = section.closest(".perfumer-hero") || section.parentElement;
  const thumbSwiperEl = wrapper ? wrapper.querySelector(".thumbs-swiper") : null;

  // pagination should live inside the main swiper
  const paginationEl = mainSwiperEl.querySelector(".swiper-pagination");

  if (!thumbSwiperEl) return;

  // Thumbnail swiper (small images)
  const thumbSwiper = new Swiper(thumbSwiperEl, {
    spaceBetween: 0,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
  });

  // Main gallery swiper config
  const mainSwiperOptions = {
    spaceBetween: 0,
    speed: 900,
    rewind: true,
    loop: false, // IMPORTANT: loop breaks thumbs sync
    navigation: {
      nextEl: mainSwiperEl.querySelector(".swiper-button-next"),
      prevEl: mainSwiperEl.querySelector(".swiper-button-prev"),
    },
    thumbs: {
      swiper: thumbSwiper,
    },
  };

  // Add fraction pagination if element exists
  if (paginationEl) {
    mainSwiperOptions.pagination = {
      el: paginationEl,
      type: "fraction",
      renderFraction: function (currentClass, totalClass) {
        return (
          '<span class="' + currentClass + '"></span>' +
          "/" +
          '<span class="' + totalClass + '"></span>'
        );
      },
    };
  }

  new Swiper(mainSwiperEl, mainSwiperOptions);
});



// ===============================
// PRODUCT TABS WITH GSAP FADE
// ===============================
document.querySelectorAll(".tabs-group").forEach((group) => {
  const tabs = group.querySelectorAll(".tab");
  const panels = group.querySelectorAll(".tab-panel");

  if (!tabs.length || !panels.length) return;

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      if (tab.classList.contains("is-active")) return;

      const targetId = tab.getAttribute("data-tab-target");
      const nextPanel = group.querySelector(
        '.tab-panel[data-tab-panel="' + targetId + '"]'
      );
      const currentPanel = group.querySelector(".tab-panel.is-active");

      if (!nextPanel || !currentPanel) return;

      // update active tab classes
      tabs.forEach((t) => t.classList.remove("is-active"));
      tab.classList.add("is-active");

      // fade out current, then fade in next
      gsap.to(currentPanel, {
        opacity: 0,
        duration: 0.3,
        onComplete() {
          currentPanel.style.display = "none";
          currentPanel.classList.remove("is-active");

          nextPanel.style.display = "block";
          gsap.fromTo(
            nextPanel,
            { opacity: 0 },
            {
              opacity: 1,
              duration: 0.3,
              onComplete() {
                nextPanel.classList.add("is-active");
              }
            }
          );
        }
      });
    });
  });
});


// ===============================
// HOME EVENTS TABS WITH GSAP FADE
// ===============================
document.querySelectorAll(".events-tab-wrapper").forEach((group) => {
  const tabs = group.querySelectorAll(".tab");
  const panels = group.querySelectorAll(".tab-panel");

  if (!tabs.length || !panels.length) return;

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      if (tab.classList.contains("is-active")) return;

      const targetId = tab.getAttribute("data-tab-target");
      const nextPanel = group.querySelector(
        '.tab-panel[data-tab-panel="' + targetId + '"]'
      );
      const currentPanel = group.querySelector(".tab-panel.is-active");

      if (!nextPanel || !currentPanel) return;

      // update active tab classes
      tabs.forEach((t) => t.classList.remove("is-active"));
      tab.classList.add("is-active");

      // fade out current, then fade in next
      gsap.to(currentPanel, {
        opacity: 0,
        duration: 0.3,
        onComplete() {
          currentPanel.style.display = "none";
          currentPanel.classList.remove("is-active");

          nextPanel.style.display = "block";
          gsap.fromTo(
            nextPanel,
            { opacity: 0 },
            {
              opacity: 1,
              duration: 0.3,
              onComplete() {
                nextPanel.classList.add("is-active");
              }
            }
          );
        }
      });
    });
  });
});



// ===============================
// MEGA MENU
// ===============================
document.addEventListener('DOMContentLoaded', () => {
  const navContainer = document.querySelector('.nav-container-menu');
  if (!navContainer) return;

  const header = document.querySelector('.bruxa-header'); // NEW

  const items = navContainer.querySelectorAll('.bruxa-menu-item[data-menu]');
  const imageGroups = document.querySelectorAll('.list-images[data-menu]');

  /* ----------------------------
     BACKGROUND + HEADER SOLID
     ---------------------------- */

  const showBg = () => {
    navContainer.classList.add('nav-has-hover');
    if (header) header.classList.add('solid');     // NEW
  };

  const hideBg = () => {
    navContainer.classList.remove('nav-has-hover');
    if (header) header.classList.remove('solid');  // NEW
    clearActiveItems();
  };

  /* ----------------------------
     ACTIVE TOP-LEVEL ITEM
     ---------------------------- */

  const clearActiveItems = () => {
    items.forEach(i => i.classList.remove('is-active'));
  };

  /* ----------------------------
     IMAGE GROUP SWITCHER
     ---------------------------- */

  const setActiveGroup = (menuId) => {
    imageGroups.forEach(group => {
      group.classList.toggle('is-active', group.dataset.menu === menuId);
    });
  };

  const setActiveImage = (menuId, imageIndex) => {
    const group = document.querySelector(`.list-images[data-menu="${menuId}"]`);
    if (!group) return;

    const imgs = group.querySelectorAll('.mega-menu-img');
    imgs.forEach(img => img.classList.remove('is-visible'));

    const target = group.querySelector(`.mega-menu-img.img${imageIndex}`);
    if (target) {
      target.classList.add('is-visible');
    }
  };

  /* ----------------------------
     PER MENU ITEM EVENTS
     ---------------------------- */

  items.forEach(item => {
    const menuId = item.dataset.menu;
    if (!menuId) return;

    /* Top-level menu item hover */
    const activateMenuItem = () => {
      showBg();
      setActiveGroup(menuId);
      setActiveImage(menuId, 1);     // default image
      clearActiveItems();
      item.classList.add('is-active'); // keeps brackets on
    };

    item.addEventListener('mouseenter', activateMenuItem);
    item.addEventListener('focusin', activateMenuItem);

    /* Mega-menu item hover (item1,item2,item3…) */
    const megaLinks = item.querySelectorAll('.mega-menu-item');

    megaLinks.forEach(link => {
      const className = Array.from(link.classList).find(c => /^item[1-5]$/.test(c));
      if (!className) return;

      const index = parseInt(className.replace('item', ''), 10);

      const activateImage = () => {
        showBg();
        setActiveGroup(menuId);
        setActiveImage(menuId, index);
        clearActiveItems();
        item.classList.add('is-active');
      };

      link.addEventListener('mouseenter', activateImage);
      link.addEventListener('focusin', activateImage);
    });

    /* Leaving the item */
    item.addEventListener('mouseleave', () => {
      const stillOverNavItem = navContainer.querySelector('.bruxa-menu-item:hover');
      if (!stillOverNavItem) hideBg();
    });

    item.addEventListener('focusout', (e) => {
      if (!item.contains(e.relatedTarget)) {
        const stillOverNavItem = navContainer.querySelector('.bruxa-menu-item:hover');
        if (!stillOverNavItem) hideBg();
      }
    });
  });

  /* ----------------------------
     SAFETY: leaving whole nav
     ---------------------------- */

  navContainer.addEventListener('mouseleave', hideBg);

  /* ----------------------------
     OPTIONAL: default state
     ---------------------------- */

  if (imageGroups[0]) {
    imageGroups[0].classList.add('is-active');
    const firstMenuId = imageGroups[0].dataset.menu;
    setActiveImage(firstMenuId, 1);
  }
});



